module.exports = __webpack_public_path__ + "img/Brokrage Calculator.592fac8b.svg";